// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PlusBadge":"ber_a bie_rj bie_rk bie_vh bie_eb bie_vf bie_gs bie_kh"};